import useRandomIds from '@/shared/hooks/useRandomIds';

export const BitcoinTransparentLogo = (
  props?: React.SVGProps<SVGSVGElement>,
): React.JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.942 8.25085C16.1943 6.56116 14.9078 5.65282 13.1487 5.04686L13.7193 2.75796L12.3257 2.41074L11.7701 4.63932C11.4042 4.54805 11.028 4.46194 10.6542 4.37662L11.2138 2.13336L9.82129 1.78613L9.25025 4.07424C8.94708 4.00519 8.64946 3.93694 8.36057 3.86511L8.36215 3.85797L6.44072 3.3782L6.07008 4.86631C6.07008 4.86631 7.10381 5.10321 7.08199 5.1179C7.64628 5.25877 7.74866 5.63218 7.7312 5.92822L7.08119 8.53577C7.12008 8.54569 7.17048 8.55998 7.22604 8.5822L7.07921 8.54569L6.1677 12.1985C6.09865 12.3699 5.92365 12.6271 5.5292 12.5294C5.54309 12.5497 4.5165 12.2767 4.5165 12.2767L3.82483 13.8719L5.63833 14.3239C5.84307 14.3752 6.04532 14.428 6.24535 14.4802C6.37487 14.5139 6.50346 14.5475 6.63119 14.5802L6.0546 16.8957L7.44628 17.243L8.01771 14.9525C8.39747 15.0556 8.76652 15.1509 9.12763 15.2406L8.55858 17.5203L9.95184 17.8676L10.5284 15.5568C12.9042 16.0064 14.6912 15.8251 15.4423 13.6767C16.0483 11.9465 15.4126 10.9485 14.1626 10.2973C15.0729 10.0866 15.7586 9.48776 15.9416 8.25085H15.942ZM12.7581 12.7149C12.3625 14.3028 9.87643 13.6458 8.73994 13.3454C8.63816 13.3185 8.54721 13.2945 8.46956 13.2752L9.23464 10.2081C9.32956 10.2318 9.44552 10.2578 9.57689 10.2873C10.7526 10.5511 13.1622 11.0918 12.7585 12.7149H12.7581ZM9.81308 8.86444C10.7614 9.11743 12.8284 9.66888 13.1885 8.22634C13.5566 6.75057 11.5467 6.30577 10.565 6.08854C10.4547 6.06412 10.3573 6.04257 10.2778 6.02276L9.58412 8.80452C9.64975 8.82087 9.72679 8.84142 9.81308 8.86444Z"
      fill="#FEAB47"
    />
  </svg>
);

export const ChainflipTransparentLogo = (
  props?: React.SVGProps<SVGSVGElement>,
): React.JSX.Element => {
  const [paint0Id, paint1Id] = useRandomIds(ChainflipTransparentLogo.name, 2, [props]);

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.7881 3V8.8702C16.7881 9.91379 16.4579 10.9248 15.8619 11.7564C15.6766 12.0173 15.4672 12.2537 15.2337 12.4739L15.2176 12.482H12.4632V7.04392H9.91011H7.33289H7.10738H4.56238L4.59459 7.01131L6.75302 4.98119L7.55034 4.23927C8.45237 3.39135 9.5638 3 10.788 3H16.7881Z"
        fill={`url(#${paint0Id})`}
      />
      <path
        d="M15.2176 12.49L15.2096 12.4982L15.2015 12.5063L15.0566 12.6449L14.5089 13.1667L12.5196 15.0338L12.3263 15.2132C11.4243 16.0529 10.2404 16.5095 9.02425 16.5095H3V13.8842L3.00805 12.4819L3.02416 10.6148C3.03222 9.25328 3.58793 7.96509 4.57049 7.03564H7.1155H7.12355V12.4819H15.2176V12.49Z"
        fill={`url(#${paint1Id})`}
      />
      <defs>
        <linearGradient
          id={paint0Id}
          x1="10.9644"
          y1="2.4209"
          x2="10.174"
          y2="17.3195"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#48EF8A" />
          <stop offset="0.5458" stopColor="#43B4A6" />
          <stop offset="0.6918" stopColor="#2D796F" />
          <stop offset="0.9662" />
        </linearGradient>
        <linearGradient
          id={paint1Id}
          x1="9.47251"
          y1="17.2486"
          x2="7.39745"
          y2="1.98207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF5F96" />
          <stop offset="0.6103" stopColor="#FF33AF" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EthereumTransparentLogo = (
  props?: React.SVGProps<SVGSVGElement>,
): React.JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.92209 2L9.81458 2.36542V12.9691L9.92209 13.0764L14.8442 10.167L9.92209 2Z"
      fill="white"
    />
    <path d="M9.92261 2L5.00049 10.167L9.92261 13.0765V7.92976V2Z" fill="white" />
    <path
      d="M9.92301 14.678L9.86243 14.7519V18.5291L9.92301 18.7061L14.8481 11.77L9.92301 14.678Z"
      fill="white"
    />
    <path d="M9.92212 18.7061V14.678L5 11.77L9.92212 18.7061Z" fill="white" />
    <path d="M9.92224 13.0768L14.8443 10.1674L9.92224 7.93018V13.0768Z" fill="white" />
    <path d="M5 10.1674L9.92204 13.0769V7.93018L5 10.1674Z" fill="white" />
  </svg>
);

export const PolkadotTransparentLogo = (
  props?: React.SVGProps<SVGSVGElement>,
): React.JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.55973 5.33284C2.47327 6.59846 2.44463 8.36016 3.49802 9.26422C4.55142 10.1704 6.28579 9.87715 7.37445 8.60932C8.46088 7.34372 8.48957 5.582 7.43616 4.67798C7.02405 4.323 6.50397 4.15322 5.96184 4.15322C5.12 4.15322 4.22086 4.56333 3.55973 5.33284Z"
      fill="#E5E7EB"
    />
    <path
      d="M3.24456 11.8814C2.42697 12.8516 2.78177 14.4986 4.03791 15.5592C5.29407 16.6198 6.97775 16.6947 7.79535 15.7246C8.61295 14.7544 8.25814 13.1073 7.00198 12.0468C6.33645 11.4845 5.5519 11.2001 4.84009 11.2001C4.20761 11.2001 3.63022 11.425 3.24676 11.8814"
      fill="#E5E7EB"
    />
    <path
      d="M10.6202 15.4313C9.14595 15.8965 8.13 16.8446 8.35034 17.548C8.57293 18.2514 9.94808 18.4454 11.4224 17.978C12.8968 17.5127 13.9127 16.5647 13.6923 15.8613C13.5513 15.4181 12.9518 15.1756 12.1585 15.1756C11.6935 15.1756 11.1646 15.2571 10.6202 15.4291"
      fill="#E5E7EB"
    />
    <path
      d="M8.3133 2.73094C8.0092 3.60849 8.97444 4.74181 10.473 5.26438C11.9716 5.78693 13.4327 5.49809 13.7368 4.62054C14.0409 3.74299 13.0757 2.60967 11.5771 2.0871C11.0724 1.91071 10.57 1.82692 10.116 1.82692C9.22347 1.82692 8.51385 2.14884 8.3133 2.73094Z"
      fill="#E5E7EB"
    />
    <path
      d="M15.0503 4.4995C14.6161 4.67369 14.7197 5.94152 15.2794 7.3262C15.8392 8.71311 16.6435 9.69427 17.0777 9.52008C17.5096 9.3459 17.4083 8.08028 16.8485 6.69339C16.3328 5.41454 15.6078 4.47966 15.1582 4.47966C15.1208 4.47966 15.0855 4.48628 15.0503 4.4995Z"
      fill="#E5E7EB"
    />
    <path
      d="M15.3828 12.9244C14.7658 14.2627 14.552 15.482 14.9068 15.6452C15.2616 15.8084 16.0506 14.8559 16.6676 13.5175C17.2869 12.1791 17.4984 10.9598 17.1458 10.7966C17.1194 10.7834 17.0908 10.779 17.0577 10.779C16.672 10.779 15.9536 11.6874 15.3828 12.9244Z"
      fill="#E5E7EB"
    />
  </svg>
);

export const ArbitrumTransparentLogo = (
  props?: React.SVGProps<SVGSVGElement>,
): React.JSX.Element => {
  const [clip0Id, clip1Id] = useRandomIds(ArbitrumTransparentLogo.name, 2, [props]);
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clip0Id})`}>
        <g clipPath={`url(#${clip1Id})`}>
          <path
            d="M3.03564 7.59883V14.2627C3.03564 14.6911 3.26004 15.0787 3.63404 15.2963L9.40716 18.6283C9.77435 18.8391 10.2299 18.8391 10.5971 18.6283L16.3703 15.2963C16.7375 15.0855 16.9687 14.6911 16.9687 14.2627V7.59883C16.9687 7.17044 16.7443 6.78284 16.3703 6.56525L10.5971 3.23329C10.2299 3.0225 9.77435 3.0225 9.40716 3.23329L3.63404 6.56525C3.26684 6.77604 3.04244 7.17044 3.04244 7.59883H3.03564Z"
            fill="#213147"
          />
          <path
            d="M11.257 12.2231L10.4342 14.4807C10.4138 14.5419 10.4138 14.6099 10.4342 14.6779L11.8486 18.5607L13.4874 17.6155L11.5222 12.2231C11.4746 12.1007 11.3046 12.1007 11.257 12.2231Z"
            fill="#12AAFF"
          />
          <path
            d="M12.9094 8.4292C12.8618 8.3068 12.6918 8.3068 12.6442 8.4292L11.8215 10.6868C11.8011 10.748 11.8011 10.816 11.8215 10.884L14.1402 17.2419L15.779 16.2967L12.9094 8.436V8.4292Z"
            fill="#12AAFF"
          />
          <path
            d="M9.99865 3.48514C10.0395 3.48514 10.0803 3.49874 10.1142 3.51914L16.3566 7.12309C16.4314 7.16389 16.4722 7.24549 16.4722 7.32709V14.535C16.4722 14.6166 16.4246 14.6982 16.3566 14.739L10.1142 18.3429C10.0803 18.3633 10.0395 18.3769 9.99865 18.3769C9.95785 18.3769 9.91705 18.3633 9.88305 18.3429L3.64074 14.739C3.56594 14.6982 3.52514 14.6166 3.52514 14.535V7.32029C3.52514 7.23869 3.57274 7.15709 3.64074 7.11629L9.88305 3.51234C9.91705 3.49194 9.95785 3.47834 9.99865 3.47834V3.48514ZM9.99865 2.43115C9.77425 2.43115 9.55666 2.48555 9.35266 2.60115L3.11035 6.2051C2.70915 6.4363 2.46436 6.85789 2.46436 7.32029V14.5282C2.46436 14.9906 2.70915 15.4122 3.11035 15.6434L9.35266 19.2473C9.54986 19.3629 9.77425 19.4173 9.99865 19.4173C10.223 19.4173 10.4406 19.3629 10.6446 19.2473L16.887 15.6434C17.2882 15.4122 17.5329 14.9906 17.5329 14.5282V7.32029C17.5329 6.85789 17.2882 6.4363 16.887 6.2051L10.6378 2.60115C10.4406 2.48555 10.2162 2.43115 9.99185 2.43115H9.99865Z"
            fill="#9DCCED"
          />
          <path
            d="M5.86475 17.2481L6.44261 15.6709L7.59834 16.6295L6.5174 17.622L5.86475 17.2481Z"
            fill="#213147"
          />
          <path
            d="M9.46831 6.80953H7.88394C7.76834 6.80953 7.65954 6.88433 7.61874 6.99313L4.22559 16.2954L5.86436 17.2406L9.60431 6.99313C9.63831 6.89793 9.57031 6.80273 9.47511 6.80273L9.46831 6.80953Z"
            fill="white"
          />
          <path
            d="M12.2426 6.80953H10.6582C10.5426 6.80953 10.4338 6.88433 10.393 6.99313L6.51709 17.6146L8.15587 18.5598L12.3718 6.99313C12.4058 6.89793 12.3378 6.80273 12.2426 6.80273V6.80953Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id={clip0Id}>
          <rect width="18" height="18" fill="white" transform="translate(1.00195 1.93115)" />
        </clipPath>
        <clipPath id={clip1Id}>
          <rect
            width="16.9998"
            height="16.9998"
            fill="white"
            transform="translate(1.49902 2.43115)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SolanaTransparentLogo = ({
  height = 20,
  width = 20,
  ...props
}: React.SVGProps<SVGSVGElement> = {}): React.JSX.Element => {
  const [clip0Id, paint0Id, paint1Id, paint2Id, paint3Id, paint4Id, paint5Id] = useRandomIds(
    SolanaTransparentLogo.name,
    7,
    [props],
  );

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clip0Id})`}>
        <path
          d="M4.78144 13.753C4.82996 13.7045 4.89718 13.6757 4.96891 13.6757H17.7383C17.7393 13.6757 17.74 13.6758 17.7406 13.6758C17.7409 13.6763 17.7412 13.6769 17.7416 13.6777C17.7419 13.6786 17.7421 13.6792 17.7422 13.6797C17.7419 13.6801 17.7414 13.6807 17.7407 13.6813L15.2182 16.2038C15.1697 16.2523 15.1025 16.281 15.0308 16.281H2.26134C2.26038 16.281 2.25964 16.281 2.2591 16.2809C2.25881 16.2805 2.25845 16.2799 2.2581 16.2791C2.25776 16.2782 2.25758 16.2776 2.25748 16.2771C2.25782 16.2766 2.25829 16.2761 2.25894 16.2755L4.78144 13.753Z"
          fill={`url(#${paint0Id})`}
          stroke={`url(#${paint1Id})`}
          strokeWidth="0.516658"
        />
        <path
          d="M4.59878 4.15263C4.69936 4.05608 4.83212 3.99976 4.96891 3.99976H17.7383C17.9717 3.99976 18.0883 4.28138 17.9234 4.44632L15.4009 6.96883C15.3043 7.06538 15.1716 7.12171 15.0308 7.12171H2.26134C2.028 7.12171 1.91133 6.84009 2.07627 6.67514L4.59878 4.15263Z"
          fill={`url(#${paint2Id})`}
        />
        <path
          d="M2.25894 6.85781L4.7793 4.33744C4.83469 4.28503 4.90374 4.25808 4.96891 4.25808H17.7383C17.7393 4.25808 17.74 4.25813 17.7406 4.25818C17.7409 4.25861 17.7412 4.25923 17.7416 4.26007C17.7419 4.26089 17.7421 4.26157 17.7422 4.26207C17.7419 4.26248 17.7414 4.26301 17.7407 4.26366L15.2182 6.78616C15.1697 6.83467 15.1025 6.86338 15.0308 6.86338H2.26134C2.26038 6.86338 2.25964 6.86334 2.2591 6.86328C2.25881 6.86286 2.25845 6.86224 2.2581 6.86139C2.25776 6.86057 2.25758 6.85989 2.25748 6.85939C2.25782 6.85898 2.25829 6.85845 2.25894 6.85781Z"
          stroke={`url(#${paint3Id})`}
          strokeOpacity="0.5"
          strokeWidth="0.516658"
        />
        <path
          d="M15.0308 8.93625C15.1025 8.93625 15.1697 8.96495 15.2182 9.01346L17.7407 11.536C17.7414 11.5366 17.7419 11.5371 17.7422 11.5376C17.7421 11.5381 17.7419 11.5387 17.7416 11.5396C17.7412 11.5404 17.7409 11.541 17.7406 11.5414C17.74 11.5415 17.7393 11.5415 17.7383 11.5415H4.96891C4.89718 11.5415 4.82996 11.5128 4.78144 11.4643L2.25894 8.94182C2.25829 8.94117 2.25782 8.94064 2.25748 8.94023C2.25758 8.93973 2.25776 8.93906 2.2581 8.93823C2.25845 8.93739 2.25881 8.93677 2.2591 8.93634C2.25964 8.93629 2.26038 8.93625 2.26134 8.93625H15.0308Z"
          fill={`url(#${paint4Id})`}
          stroke={`url(#${paint5Id})`}
          strokeWidth="0.516658"
        />
      </g>
      <defs>
        <linearGradient
          id={paint0Id}
          x1="16.5185"
          y1="2.49239"
          x2="7.68102"
          y2="19.4197"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset="1" stopColor="#DC1FFF" />
        </linearGradient>
        <linearGradient
          id={paint1Id}
          x1="1.99902"
          y1="14.9784"
          x2="18.0006"
          y2="14.9784"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DF59F3" />
          <stop offset="1" stopColor="#91B4E0" />
        </linearGradient>
        <linearGradient
          id={paint2Id}
          x1="12.6543"
          y1="0.475435"
          x2="3.8168"
          y2="17.4027"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset="1" stopColor="#DC1FFF" />
        </linearGradient>
        <linearGradient
          id={paint3Id}
          x1="1.99902"
          y1="5.56073"
          x2="18.0006"
          y2="5.56073"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D4B5E8" />
          <stop offset="0.229137" stopColor="#67C9D7" />
          <stop offset="1" stopColor="#17F3C6" />
        </linearGradient>
        <linearGradient
          id={paint4Id}
          x1="14.5741"
          y1="1.47699"
          x2="5.73661"
          y2="18.4043"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset="1" stopColor="#DC1FFF" />
        </linearGradient>
        <linearGradient
          id={paint5Id}
          x1="1.99902"
          y1="10.2389"
          x2="18.0006"
          y2="10.2389"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B293E9" />
          <stop offset="1" stopColor="#6EC6D8" />
        </linearGradient>
        <clipPath id={clip0Id}>
          <rect width="16" height="12.5401" fill="white" transform="translate(2 3.99982)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AssethubTransparentLogo = (
  props?: React.SVGProps<SVGSVGElement>,
): React.JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g transform="translate(4 3)">
      <path
        d="M2.18078 4.0583C1.03041 5.39837 1.00008 7.2637 2.11544 8.22094C3.2308 9.18042 5.06719 8.86992 6.21989 7.52752C7.37023 6.18746 7.4006 4.32212 6.28523 3.36492C5.84888 2.98905 5.2982 2.80929 4.72418 2.80929C3.83283 2.80929 2.88079 3.24353 2.18078 4.0583Z"
        fill="white"
      />
      <path
        d="M1.84707 10.9921C0.98138 12.0193 1.35705 13.7632 2.68709 14.8862C4.01714 16.0092 5.79985 16.0886 6.66555 15.0613C7.53124 14.0341 7.15556 12.2901 5.82552 11.1672C5.12083 10.5718 4.29014 10.2707 3.53645 10.2707C2.86677 10.2707 2.25541 10.5088 1.8494 10.9921"
        fill="white"
      />
      <path
        d="M9.65693 14.7508C8.09592 15.2434 7.0202 16.2472 7.25351 16.992C7.4892 17.7367 8.94523 17.9422 10.5063 17.4473C12.0674 16.9547 13.143 15.9508 12.9097 15.2061C12.7604 14.7368 12.1257 14.48 11.2856 14.48C10.7933 14.48 10.2333 14.5664 9.65693 14.7485"
        fill="white"
      />
      <path
        d="M7.21385 1.30335C6.89186 2.23252 7.91388 3.43251 9.50062 3.98581C11.0873 4.53911 12.6344 4.23328 12.9563 3.3041C13.2784 2.37493 12.2564 1.17494 10.6696 0.621639C10.1353 0.43487 9.60328 0.346155 9.12263 0.346155C8.17755 0.346155 7.4262 0.687008 7.21385 1.30335Z"
        fill="white"
      />
      <path
        d="M14.3471 3.17595C13.8874 3.36038 13.9971 4.70278 14.5898 6.16892C15.1824 7.63741 16.0341 8.67628 16.4938 8.49185C16.9511 8.30742 16.8439 6.96735 16.2512 5.49888C15.7051 4.14481 14.9375 3.15494 14.4615 3.15494C14.4218 3.15494 14.3845 3.16194 14.3471 3.17595Z"
        fill="white"
      />
      <path
        d="M14.6994 12.0964C14.046 13.5135 13.8197 14.8045 14.1954 14.9773C14.5711 15.1501 15.4065 14.1415 16.0598 12.7244C16.7155 11.3073 16.9395 10.0162 16.5661 9.84347C16.5381 9.82948 16.5078 9.82484 16.4728 9.82484C16.0644 9.82484 15.3038 10.7867 14.6994 12.0964Z"
        fill="white"
      />
    </g>
  </svg>
);

export const TronTransparentLogo = (props?: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.3695 8.6232C19.5396 7.88558 18.3871 6.76186 17.4536 5.96662L17.3959 5.93204C17.3037 5.86289 17.2 5.80527 17.0905 5.76493C14.8316 5.36154 4.3205 3.47716 4.11881 3.50021C4.06118 3.50597 4.00355 3.52902 3.95745 3.55784L3.90559 3.59817C3.8422 3.66156 3.79034 3.73648 3.76152 3.82292L3.75 3.85749V4.07647C4.93134 7.2344 9.60484 17.5726 10.5269 20.0044C10.5845 20.1715 10.6882 20.4827 10.8841 20.5H10.9302C11.034 20.5 11.4835 19.9295 11.4835 19.9295C11.4835 19.9295 19.5108 10.6055 20.3234 9.61437C20.4271 9.49336 20.5193 9.36082 20.6 9.22251C20.623 9.11302 20.6115 9.00353 20.5711 8.8998C20.5308 8.79608 20.4559 8.69811 20.3695 8.6232ZM13.535 9.71234L16.958 6.99237L18.9691 8.76726L13.535 9.71234ZM12.2038 9.53369L6.30861 4.90053L15.8515 6.58898L12.2038 9.53369ZM12.734 10.7438L18.7674 9.8103L11.8696 17.78L12.734 10.7438ZM5.50761 5.36731L11.714 10.4096L10.815 17.7858L5.50761 5.36731Z"
      fill="white"
    />
  </svg>
);

export const BscTransparentLogo = (props?: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.03571 10.1L5.04362 13.0012L7.50869 14.4518V16.1503L3.60098 13.8583V9.25162L5.03571 10.1ZM5.03571 7.19882V8.88941L3.6001 8.04016V6.34956L5.03571 5.50031L6.47836 6.34956L5.03571 7.19882ZM8.53815 6.34956L9.97376 5.50031L11.4164 6.34956L9.97376 7.19882L8.53815 6.34956Z"
      fill="white"
    />
    <path
      d="M6.07373 12.3998V10.7013L7.50934 11.5506V13.2412L6.07373 12.3998ZM8.5388 15.0601L9.97441 15.9094L11.4171 15.0601V16.7507L9.97441 17.6L8.5388 16.7507V15.0601ZM13.476 6.34956L14.9116 5.50031L16.3542 6.34956V8.04016L14.9116 8.88941V7.19882L13.476 6.34956ZM14.9116 13.0012L14.9195 10.1L16.3551 9.25074V13.8575L12.4474 16.1494V14.4509L14.9116 13.0012Z"
      fill="white"
    />
    <path d="M13.8804 12.3999L12.4448 13.2412V11.5506L13.8804 10.7014V12.3999Z" fill="white" />
    <path
      d="M13.8821 7.80015L13.89 9.49866L11.4179 10.9492V13.8575L9.98233 14.6988L8.54671 13.8575V10.9492L6.07461 9.49866V7.80015L7.51638 6.95089L9.97353 8.40852L12.4456 6.95089L13.8883 7.80015H13.8821ZM6.07373 4.89984L9.97441 2.6L13.8821 4.89984L12.4465 5.7491L9.97441 4.29148L7.50934 5.7491L6.07373 4.89984Z"
      fill="white"
    />
  </svg>
);
